// extracted by mini-css-extract-plugin
export default {"keycloakLoading":"KeycloakLoadingContent_keycloakLoading__QZxTF"};